import { useId } from 'react';
import { RadioGroup, FormControl, FormLabel, FormControlLabel, Radio, TextField } from '@mui/material';
import { McpAccessScope } from '../../../store/McpAccess';
import { SCOPE_LABELS } from './mcpAccessLabels';

interface McpAccessFieldsProps {
  title: string;
  scope: McpAccessScope;
  allowedScopes: McpAccessScope[];
  onTitleChange: (title: string) => void;
  onScopeChange: (scope: McpAccessScope) => void;
}

export const McpAccessFields = ({
  title,
  scope,
  allowedScopes,
  onTitleChange,
  onScopeChange
}: McpAccessFieldsProps) => {
  const scopeLabelId = useId();
  const singleScope = allowedScopes.length === 1;

  return (
    <>
      <TextField
        label="Title"
        value={title}
        onChange={(event) => onTitleChange(event.target.value)}
        required
        fullWidth
        size="small"
        slotProps={{ htmlInput: { maxLength: 120 } }}
      />
      <FormControl>
        <FormLabel id={scopeLabelId}>Access scope</FormLabel>
        {singleScope ? (
          <span data-testid="mcp-scope-fixed">{SCOPE_LABELS[scope]}</span>
        ) : (
          <RadioGroup
            aria-labelledby={scopeLabelId}
            value={scope}
            onChange={(event) => onScopeChange(event.target.value as McpAccessScope)}>
            {allowedScopes.map((allowed) => (
              <FormControlLabel
                key={allowed}
                value={allowed}
                control={<Radio />}
                label={SCOPE_LABELS[allowed]}
              />
            ))}
          </RadioGroup>
        )}
      </FormControl>
    </>
  );
};
